const cccContactForms = document.querySelectorAll(".cccContactForm");

cccContactForms.forEach((section) => {
  const form = section.querySelector("form");
  const formMessageSuccess = section.querySelector(
    ".cccContactForm-form-content-message-success"
  );
  const formMessageError = section.querySelector(
    ".cccContactForm-form-content-message-error"
  );
  const formButton = section.querySelector(
    ".cccContactForm-form-content-button"
  );

  turnstile.ready(function () {
    turnstile.render(section.querySelector("#cf-turnstile"), {
      sitekey: "0x4AAAAAACMPiAmPzNU02Nt5",
    });
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    formButton.classList.add("cccContactForm-form-content-button__loading");
    formButton.disabled = true;

    const formData = new FormData(form);
    const formDataObject = Object.fromEntries(formData.entries());

    const response = await fetch(
      "https://control.earthpositivefuture.com/api/contact-submissions",
      {
        method: "POST",
        body: JSON.stringify(formDataObject),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    if (response.status === 201) {
      formMessageSuccess.style.display = "block";
      formMessageError.style.display = "none";
    } else {
      formMessageSuccess.style.display = "none";
      formMessageError.style.display = "block";
    }

    formButton.classList.remove("cccContactForm-form-content-button__loading");
    formButton.disabled = false;
  });

  // mobile title info
  const titleInfo = section.querySelector(".cccContactForm-form-title-info");
  const titleInfoButton = titleInfo.querySelector(
    ".cccContactForm-form-title-info-icon"
  );
  const titleInfoOverlay = section.querySelector(
    ".cccContactForm-form-title-info-overlay"
  );
  const titleInfoContent = section.querySelector(
    ".cccContactForm-form-title-info-content"
  );
  const titleInfoClose = section.querySelector(
    ".cccContactForm-form-title-info-close"
  );

  function openTitleInfoContentMobile() {
    titleInfoOverlay.classList.add(
      "cccContactForm-form-title-info-overlay__active"
    );
    titleInfoContent.classList.add(
      "cccContactForm-form-title-info-content__active"
    );
  }
  function closeTitleInfoContentMobile() {
    titleInfoOverlay.classList.remove(
      "cccContactForm-form-title-info-overlay__active"
    );
    titleInfoContent.classList.remove(
      "cccContactForm-form-title-info-content__active"
    );
  }

  titleInfoButton.addEventListener("click", () => {
    if (window.innerWidth < 750) {
      openTitleInfoContentMobile();
    }
  });
  titleInfoClose.addEventListener("click", () => {
    if (window.innerWidth < 750) {
      closeTitleInfoContentMobile();
    }
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 750) {
      closeTitleInfoContentMobile();
    }
  });
});